import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "button-primary-orange-component",
  template: `
    <button
      type="button"
      [disabled]="disabled"      
      (click)="onClick.emit($event)"
    >
      {{ label }}
    </button>
  `,
  styleUrls: ["./button-primary-orange.component.scss"],
})
export class ButtonPrimaryOrangeComponent {
  @Input() label: string = "Click me";
  @Input() buttonClass: string = "";
  @Input() disabled: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();
}
